import HomeWhyChooseUs from "../home/HomeWhyChooseUs";

const WhyBody = () => {
  return (
    <section className="why">
      <HomeWhyChooseUs />
    </section>
  );
};

export default WhyBody;
